class Draw {
	/**
	 * @param {HTMLCanvasElement} canvas 
	 */
	constructor(canvas) {
		this.canvas = canvas

		this.lineWidth = 4
		this.color = '#cc0033'
		/**
		 * @type {CanvasLineCap}
		 */
		this.lineCap = 'round'
		/**
		 * @type {'draw' | 'clear'}
		 */
		this.mode = 'draw'

		this.init(canvas)
	}

	/**
	 * 
	 * @param {HTMLCanvasElement} canvas 
	 */
	init(canvas) {
		const ctx = canvas.getContext('2d')
		const isMobile = window.navigator.userAgent.match(/(iphone|android|ipad)/i)
		if (isMobile) {

			let x, y
			canvas.ontouchstart = event => {
				const clientRect = canvas.getBoundingClientRect()
				x = clientRect.x
				y = clientRect.y
				const {
					pageX,
					pageY
				} = event.targetTouches[0]
				ctx.beginPath()

				if (this.mode === 'draw') {
					ctx.moveTo(pageX - x, pageY - y)
				}
				ctx.moveTo(pageX - x, pageY - y)
				ctx.lineCap = this.lineCap
				ctx.lineWidth = this.lineWidth
				ctx.strokeStyle = this.color
				ctx.lineJoin = 'round'

			}
			canvas.ontouchmove = event => {
				
				const {
					pageX,
					pageY
				} = event.targetTouches[0]


				if (this.mode === 'draw') {
					ctx.lineTo(pageX - x, pageY - y)
					ctx.stroke()
				}

				if (this.mode === 'clear') {
					ctx.clearRect(pageX - x - 8, pageY - y - 8, 16, 16)
				}

			}
			canvas.ontouchend = event => {
				
				ctx.closePath()
			}
		}

		canvas.onmousedown = null
		canvas.onmousedown = (event) => {
			ctx.beginPath()

			if (this.mode === 'draw') {
				ctx.moveTo(event.layerX, event.layerY)
			}

			// ------------
			ctx.lineCap = this.lineCap
			ctx.lineWidth = this.lineWidth
			ctx.strokeStyle = this.color
			ctx.lineJoin = 'round'

			// onMousedown(event)
			canvas.onmousemove = (event) => {

				if (this.mode === 'draw') {
					ctx.lineTo(event.layerX, event.layerY)
					ctx.stroke()
				}

				if (this.mode === 'clear') {
					ctx.clearRect(event.layerX - 8, event.layerY - 8, 16, 16)
				}
				// onMousemove(event)
			}
			canvas.onmouseup = mousestop
			canvas.onmouseleave = mousestop

			function mousestop() {
				ctx.closePath()

				// onMousestop()
				canvas.onmousemove = null
			}
		}
	}

	setConfig(config) {
		const {
			color = this.color,
				lineWidth = this.lineWidth,
				lineCap = this.lineCap
		} = config

		this.color = color
		this.lineWidth = lineWidth
		this.lineCap = lineCap
		this.init(this.canvas)
	}

	/**
	 * 
	 * @param {'draw' | 'clear'} modeName 
	 */
	setMode(modeName) {
		this.mode = modeName
		this.color = modeName === 'draw' ? this.color : canvas.style.backgroundColor
	}

	applyMode(mode) {}
}

export default Draw;
